import { Component, OnInit, HostListener } from '@angular/core';
import * as L from 'leaflet';

@Component({
    selector: 'md-agencies-map',
    templateUrl: './agencies-map.component.html',
    styleUrls: ['./agencies-map.component.scss'],
})
export class AgenciesMapComponent implements OnInit {
    private map: L.Map;
    private markers: L.Marker[] = [];
    private markerMap: { [name: string]: L.Marker } = {};

    shouldShowLocations = true;

    private readonly LOCATIONS_BREAKPOINT = 995;

    private agencies = [
        {
            name: 'Trianon',
            lat: -20.258521616672855,
            lng: 57.49004097189169,
        },
        {
            name: 'Head Office',
            lat: -20.028739158594163,
            lng: 57.59066782683983,
        },
        {
            name: 'Ruisseau Créole',
            lat: -20.35866351618774,
            lng: 57.36947964200408,
        },
    ];

    ngOnInit(): void {
        this.updateLocationVisibility();
        this.initMap();
        this.addMarkers();

        setTimeout(() => {
            this.map.invalidateSize();
        }, 0);
    }

    @HostListener('window:resize', ['$event'])
    onResize(): void {
        this.updateLocationVisibility();
    }

    private updateLocationVisibility(): void {
        this.shouldShowLocations =
            window.innerWidth >= this.LOCATIONS_BREAKPOINT;
    }

    private initMap(): void {
        const mauritiusCenter: L.LatLngTuple = [
            -20.247517175839196, 57.588458518809425,
        ];

        this.map = L.map('agencies-map', {
            zoomControl: false,
            scrollWheelZoom: true,
            keyboard: true,
            touchZoom: true,
            doubleClickZoom: true,
            dragging: true,
            attributionControl: false,
        }).setView(mauritiusCenter, 10);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; OpenStreetMap contributors',
            detectRetina: true,
        }).addTo(this.map);
    }

    private addMarkers(): void {
        const customIcon = L.icon({
            iconUrl: 'assets/img/ICONS/map-marker-icon.png',
            iconSize: [40, 40],
            iconAnchor: [15, 40],
            popupAnchor: [0, -40],
        });

        this.agencies.forEach((agency) => {
            const marker = L.marker([agency.lat, agency.lng], {
                icon: customIcon,
            }).addTo(this.map);

            const popupHtml = `<div class="popup-link" data-name="${agency.name}" style="cursor: pointer; color: #007bff; text-decoration: none; font-size:15px;">${agency.name}</div>`;

            marker.bindPopup(popupHtml);
            this.markers.push(marker);
            this.markerMap[agency.name] = marker;
        });

        this.map.on('popupopen', (e: L.PopupEvent) => {
            const popupEl = e.popup.getElement();
            const link = popupEl?.querySelector('.popup-link');
            if (link) {
                link.addEventListener('click', () => {
                    const name = link.getAttribute('data-name');
                    const agency = this.agencies.find((a) => a.name === name);
                    if (agency) {
                        const url = `https://www.google.com/maps?q=${agency.lat},${agency.lng}`;
                        window.location.href = url;
                    }
                });
            }
        });
    }

    highlightMarker(name: string): void {
        const marker = this.markerMap[name];
        if (marker) {
            marker.setZIndexOffset(1000);

            const scaledIcon = L.icon({
                iconUrl: 'assets/img/ICONS/map-marker-icon.png',
                iconSize: [50, 50],
                iconAnchor: [20, 40],
                popupAnchor: [0, -40],
            });

            marker.setIcon(scaledIcon);
        }
    }

    resetMarker(name: string): void {
        const marker = this.markerMap[name];
        if (marker) {
            marker.setZIndexOffset(0);

            const originalIcon = L.icon({
                iconUrl: 'assets/img/ICONS/map-marker-icon.png',
                iconSize: [40, 40],
                iconAnchor: [15, 40],
                popupAnchor: [0, -40],
            });

            marker.setIcon(originalIcon);
        }
    }

    openInGoogleMaps(name: string): void {
        const agency = this.agencies.find((a) => a.name === name);
        if (!agency) {
            console.warn('Agency not found:', name);
            return;
        }

        const url = `https://www.google.com/maps?q=${agency.lat},${agency.lng}`;
        window.open(url, '_blank');
    }
}
